import { render, staticRenderFns } from "./offer-row.vue?vue&type=template&id=52ee8c57&scoped=true&"
import script from "./offer-row.vue?vue&type=script&lang=js&"
export * from "./offer-row.vue?vue&type=script&lang=js&"
import style0 from "./offer-row.vue?vue&type=style&index=0&id=52ee8c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee8c57",
  null
  
)

export default component.exports